var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page-landscapeunavailable",class:_vm.className},[_c('img',{staticClass:"logo",attrs:{"src":require("@/Asset/image/branding/zoodi.png"),"height":"150","alt":"ZoodiCharChar"}}),_c('p',[_vm._v(_vm._s(_vm.language.copy_landscape_rotatephone))])])
}
var staticRenderFns = []

export { render, staticRenderFns }